import { render, staticRenderFns } from "./ObstacleGame.vue?vue&type=template&id=8c85f976&"
import script from "./ObstacleGame.vue?vue&type=script&lang=js&"
export * from "./ObstacleGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports